import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Message } from 'primereact/message';
import React, { useState } from "react";
import { _endPoints } from '../Helper/links';
import imgCustomer from "../public/images/user.avif";
import API from '../Helper/server/API';
import { addLocale } from 'primereact/api';

function UserAppEdit(props) {
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const [state, set_state] = useState(props?.user?.state);
    const [user_approve, set_user_approve] = useState(
        props?.user?.user_approve === 1 ? { name: 'تم التحقق', value: 1 } :
            props?.user?.user_approve === 2 ? { name: 'قيد التحقق', value: 2 } :
                props?.user?.user_approve === 3 ? { name: 'بيانات غير مطابقة', value: 3 } : { name: 'لم يتم التحقق', value: 0 }
    );
    const [control_points, set_control_points] = useState(props?.user?.control_points || 0);
    const [control_expired, set_control_expired] = useState(props?.user?.control_expired ? new Date(props?.user?.control_expired) : null);
    const [loading, setLoading] = useState(false);

    const list_approve = [
        { name: 'لم يتم التحقق', value: 0 },
        { name: 'تم التحقق', value: 1 },
        { name: 'قيد التحقق', value: 2 },
        { name: 'بيانات غير مطابقة', value: 3 },
    ];



    const UpdateUserApp = async () => {
        setLoading(true);
        const data = {
            id_user: props?.user?.ID_user,
            state: state ? 1 : 0,
            control_points: control_points,
            control_expired: control_expired ? control_expired.toISOString().split('T')[0] : null,
            user_approve: user_approve.value
        }

        const response = await API.post(_endPoints.users_app.app_update, data);
        if (response?.success) {
            props?.toast.current.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 5000,
                severity: 'success', summary: ' نجــاح ', detail: response?.msg
            });
            props?.set_show_edit(false);
            props?.GetUsersApp();
        } else {
            props?.toast.current.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg || "حدث خطأ"
            });
        }
        setLoading(false);
    }

    return (
        <div className="ibox" dir="rtl" style={{ fontFamily: "Cairo" }}>
            <div className="row">
                <div className="col-md-2 pt-5">
                    <center>
                        <Avatar image={props?.user?.image ? `${_endPoints.users.images}${props?.user?.image}` : imgCustomer} size="xlarge" style={{ width: "150px", height: "150px" }} shape="circle" />
                    </center>
                </div>

                <div className="col-md-10">
                    <hr />
                    <div className="row">
                        <div className="col-md-4 mb-4 font-bold">
                            <i className="ti-user font-26 text-muted ml-3"></i>
                            {props?.user?.name || '-'}
                        </div>
                        <div className="col-md-4 mb-4 font-bold">
                            <i className="fa fa-phone font-26 text-muted ml-3"></i>
                            <a dir='ltr' href={`tel:${props?.user?.country_code}-${props?.user?.phone}`} target="_blank" rel="noopener noreferrer">+{props?.user?.country_code}-{props?.user?.phone}</a>
                        </div>
                        <div className="col-md-4 mb-4 font-bold">
                            <i className="fa fa-whatsapp font-26 text-muted ml-3"></i>
                            {props?.user?.whatsapp_number ? <><a dir='ltr' href={`https://wa.me/${props?.user?.whatsapp_number}`} target="_blank" rel="noopener noreferrer">+{props?.user?.whatsapp_number}</a></> : '-'}
                        </div>
                    </div>
                    <hr />
                    <div className="row mt-4">
                        <div className="col-md-3 mb-4 font-bold">
                            <label className="font-bold mb-2">حالة الحساب</label>
                            <br />
                            <Button icon={state ? "pi pi-check ml-2" : "pi pi-times ml-2"} label={state ? "فعـــال" : "متــوقف"} outlined severity={state ? "success" : "danger"} size="large" className="w-full"
                                onClick={() => set_state(!state)} />
                        </div>

                        <div className="col-md-3 mb-4 font-bold">
                            <label className="font-bold mb-2">نقاط الحجز</label>
                            <br />
                            <InputNumber value={control_points} onValueChange={(e) => set_control_points(e.value)} min={0} className="w-full" showButtons />
                        </div>
                        <div className="col-md-3 mb-4 font-bold">
                            <label className="font-bold mb-2">حظر حتى</label>
                            <br />
                            <Calendar locale="ar" value={control_expired} onChange={(e) => set_control_expired(e.value)} dateFormat="yy-mm-dd" showIcon panelStyle={{ width: "30rem" }} showButtonBar />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-12">
                    <center>
                        <Button label="إغـــلاق" severity="danger" outlined icon="pi pi-times ml-2" onClick={() => props?.set_show_edit(false)} />
                        <Button label="حفظ التعديلات" severity="success" outlined icon="pi pi-check ml-2" onClick={UpdateUserApp} loading={loading} className="mr-2" />
                    </center>
                </div>
            </div>
        </div>
    );
}

export default UserAppEdit;